export default __webpack_public_path__ + "8e186bd4b02ec8c461303491851ab461.svg";